import { Application } from '@hotwired/stimulus'
import { installErrorHandler } from '@appsignal/stimulus'
import { appsignal } from '../lib/appsignal'

const application = Application.start()

// Install AppSignal error handler to capture errors from all Stimulus controllers
installErrorHandler(appsignal, application)

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

export { application }
